export const initialState = {
  forms: [],
  form: {},
  currentPage: 1,
  pageSize: 10,
  filterSearchText: "",
  filterModel: [],
  formDraftName: "",
  isLoading: false,
  rowData: [],
  showFilterModal: false,
  totalRow: 0,
  hasChanges: false,
  activeFormTab: "tab_form_editor",
  formDescription: "",
  formCategories: [],
  isOpenEditConfirmationPopup: false,
  isReloadForm: false,
  isLoaded: false,
  isFormDirty: false,
  initialFormData: {},
  formState: 1,
  formPublishState: "inactive", // Add form publish state
  
  // Alert fields
  formType: "candidate",
  isSendAlert: false,
  alertRecipients: "",
  alertUserIds: "",
  alertExternalEmails: "",
  alertSubject: "",
  alertMessage: "",
  alertFrequency: "immediately",
  alertTime: null,
  isSaveResponseAsPdf: false,
  saveResponseDocumentType: null,
  googleAnalytics: "",

  // Automation users for dropdown
  automationUsers: [],
  automationRoiUsers: []
};

export const templateInitialState = {
  templateForms: [],
  templateForm: {},
  templateCurrentPage: 1,
  templatePageSize: 10,
  templateFilterSearchText: "",
  templateFilterModel: [],
  templateTotalRow: 0,
  templateHasChanges: false,
  templateActiveFormTab: "tab_form_editor_template",
  templateFormDescription: "",
  templateFormCategories: [],
  templateFormDraftName: "",
  templateIsLoading: false,
  templateShowFilterModal: false,
  templateShowWizardModal: false,
  templateCategoryOptions: [],
  
  // Template Alert fields
  templateFormType: "candidate",
  templateIsSendAlert: false,
  templateAlertRecipients: "",
  templateAlertUserIds: "",
  templateAlertExternalEmails: "",
  templateAlertSubject: "",
  templateAlertMessage: "",
  templateAlertFrequency: "immediately",
  templateAlertTime: null,
  templateIsSaveResponseAsPdf: false,
  templateSaveResponseDocumentType: null,
  templateGoogleAnalytics: "",

  // Template Automation users for dropdown
  templateAutomationUsers: [],
  templateAutomationRoiUsers: []
};

export const formBuilderState = {
  formFace: "classic",
  formStyles: {
    autoFocus: false,
    showEnumerators: false,
    showPageIndicators: false,
    showProgressbar: false,
    noBranding: true,
    font: { size: 14, family: "Nunito" },
    inputs: {
      borderSize: 1,
      roundness: 8,
      errorColor: "red",
      agreeColor: "#ee4578",
      declineColor: "#404042",
      backgroundColor: "#fff",
      selectionColor: "#ee4578"
    },
    buttons: {
      mode: "fill",
      roundness: 8,
      finishColor: "#ee4578",
      baseColor: "#404042"
    }
  },
  formData: {},
  tripettoLoading: false,
  isRestoreForm: false,
  tripettoBuilder: null
};
